import ChooseSignupMethod from './ChooseSignupMethod';
// import ConnectYourWallet from './ConnectYourWallet';
import ChooseCountry from './ChooseCountry';
import FullName from './FullName';
import LogInWithX from './LogInWithX';
// import Password from './Password';
// import PasswordConfirm from './PasswordConfirm';
import ReviewYourApplication from './ReviewYourApplication';
import TermsAgree from './TermsAgree';
// import VerifyEmail from './VerifyEmail';
import Intro from './Intro';

type Step = {
  stepId: number;
  component: JSX.Element;
  progressOnMount: number;
};

export const steps: Step[] = [
  {
    stepId: 0,
    component: <Intro />,
    progressOnMount: 0,
  },
  {
    stepId: 1,
    component: <ChooseSignupMethod />,
    progressOnMount: 0,
  },
  // {
  //   stepId: 2,
  //   component: <Password />,
  //   progressOnMount: 0.11,
  // },
  // {
  //   stepId: 3,
  //   component: <PasswordConfirm />,
  //   progressOnMount: 0.22,
  // },
  // {
  //   stepId: 4,
  //   component: <VerifyEmail />,
  //   progressOnMount: 0.33,
  // },
  {
    stepId: 2,
    component: <FullName />,
    progressOnMount: 0.2,
  },
  {
    stepId: 3,
    component: <ChooseCountry />,
    progressOnMount: 0.4,
  },
  {
    stepId: 4,
    component: <LogInWithX />,
    progressOnMount: 0.6,
  },
  // {
  //   stepId: 8,
  //   component: <ConnectYourWallet />,
  //   progressOnMount: 0.77,
  // },
  {
    stepId: 5,
    component: <TermsAgree />,
    progressOnMount: 0.8,
  },
  {
    stepId: 6,
    component: <ReviewYourApplication />,
    progressOnMount: 1,
  },
];

export const getStepById = (stepId: number): Step | undefined =>
  steps.find((step) => step.stepId === stepId);
